// LoadingSpinner.js - Eine wiederverwendbare Loading-Komponente
import React from 'react';
import { Oval } from 'react-loader-spinner';
import colors from '../../config/colors';

/**
 * Eine wiederverwendbare Loading-Komponente
 * 
 * @param {Object} props - Komponenteneigenschaften
 * @param {number} props.height - Die Höhe des Spinners
 * @param {number} props.width - Die Breite des Spinners
 * @param {string} props.color - Die Farbe des Spinners
 * @param {string} props.containerClassName - Zusätzliche CSS-Klassen für den Container
 */
const LoadingSpinner = ({
  height = 80,
  width = 80,
  color = colors.primary,
  containerClassName = "flex justify-center items-center h-96"
}) => {
  return (
    <div className={containerClassName}>
      <Oval
        height={height}
        width={width}
        color={color}
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor={color}
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>
  );
};

export default LoadingSpinner;
